/* Package JSON Import will be here */
import React from 'react';
import { Segment, Form, Button, Image, Label, Select, Input, Icon, Radio, Modal } from 'semantic-ui-react';
import './register.css';
import "../../assets/styles/styles.css";
import { Constants } from '../../../src/config/appConstants.js';
import Loader from '../sharedComponent/loader/loader';
import packageJson from '../../../package.json';
const RegisterComponent = props => {

    return (
        <Segment className="login-bg text-center heightFormSegment">
            <Form size='large' className="text-center p-3 formWidth">
                <Image className="d-inline-block mb-3" size='small' src={require('../../assets/images/logo_1.png')}></Image>
                <div className="maxHeightForm">
                    <div className="d-flex justify-content-around align-items m-1">
                        <Label className="registerTextStyle mr-1">Division Number</Label>
                        <Select style={{ width: '100%' }}
                            className="selectDropdownView"
                            name='divisionId'
                            value={props.register && props.register.selectedDivisionId ? props.register.selectedDivisionId : ""}
                            options={props.register.divisionNumberDD}
                            // placeholder='Select division number'
                            onChange={props.handleDivisionChange}
                        />
                    </div>
                    <div className="d-flex justify-content-around align-items m-1">
                        <Label className="registerTextStyle mr-1">Full Name</Label>
                        <Input maxLength="100" style={{ width: '100%' }} className="selectDeviceName" type="text" onChange={(e) => { props.onTrimDeviceName(e, { name: 'deviceName', value: e.target.value }) }} value={props.register.fullName} />
                    </div>
                    <div className="d-flex justify-content-around align-items m-1">
                        <Label className="registerTextStyle mr-1">Device Model</Label>
                        <Input style={{ width: '100%' }} className="selectDeviceName" type="text" value={props.register.deviceType} disabled={true} />
                    </div>
                    <div className="d-inline-block justify-content-center mt-3 w-100">
                        {props.register.isDeviceAlreadyRegistered ?
                            <div>
                                <Button className="secondary loginBtn mb-2 w-50" size='medium'
                                 onClick={props.onClickSync}
                                 >
                                    <Icon name='sync' />Sync</Button>
                                <Button className="secondary loginBtn w-50" size='medium' onClick={props.onClickBack}>
                                    <Icon name='arrow alternate circle left outline' />Back</Button>
                            </div>
                            :
                            <div>
                                <Button className="secondary loginBtn mb-2 w-100" size='medium' onClick={props.onClickRegister} >
                                    <Icon name='address book outline' />Register</Button>
                                <Button className="secondary loginBtn mb-2 w-100" size='medium' onClick={props.onSelectAlreadyRegistered} >
                                    <Icon name='address book' />Already Registered</Button>
                            </div>
                        }
                    </div>

                    {/* <div class="d-inline-block justify-content-center">

                    </div> */}
                    {!props.register.isDeviceAlreadyRegistered &&
                        <Label className="versionText w-100 mt-3">V{packageJson.version}</Label>
                    }

                </div>
            </Form>
            {/* Devices select Modal */}
            <Modal
                open={props.register.isShowRegisteredDeviceModel}
                size='tiny'
            >
                <Modal.Header className="text-center">Select Registered Device</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>

                    <Form>
                        <Form.Input className="loginInput" label="Enter Employee Number"
                            icon={<><Icon name='close' circular link onClick={props.onClickClear} style={{right:'3em'}}/><Icon name='search' inverted circular link onClick={() => props.getWebDevicesByEmployeeNumber()} /></>}
                            style={{ border: 'none' }}
                            value={props.register.employeeNumber}
                            onChange={props.onEmployeeNumber} fluid />

                        {props.register.employeeRegiterdDevices &&
                            props.register.employeeRegiterdDevices.map((device) =>

                            (<Radio className="selectedRow w-100"
                                label={device.deviceEmpID}
                                onChange={props.onSelectRegisteredDevice}
                                value={device}
                                checked={props.register.selectedEmployeeDevice && props.register.selectedEmployeeDevice.deviceID === device.deviceID}
                            />))
                        }
                    </Form>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary active onClick={() => props.onCloseDeviceSelectionModel()} className="borderRadius w-25" size='small' >
                        Back
                    </Button>
                    <Button secondary active onClick={() => props.onUpdateWebDeviceFingerPrint()} className="borderRadius w-25" size='small' >
                        Update
                    </Button>
                </Modal.Actions>
                {props.register.isShowLoader &&
                <Loader />
            }
            </Modal>
            {props.register.isShowLoader &&
                <Loader />
            }
        </Segment>
    );
};

RegisterComponent.displayName = "RegisterComponent";

export default RegisterComponent;